module.exports = __webpack_public_path__ + "static/media/only-stripe.d2ae6963.svg";